import { render } from "./WishlistModal.vue?vue&type=template&id=2450db7c"
import script from "./WishlistModal.vue?vue&type=script&lang=js"
export * from "./WishlistModal.vue?vue&type=script&lang=js"

import "./WishlistModal.vue?vue&type=style&index=0&id=2450db7c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__